module.exports = __webpack_public_path__ + "img/Picture1.9a5d3780.png";